import { loadNewDeliverynoteDraftThunk } from 'client/actions/DocumentsV1/deliverynoteActions'
import { copyDraftV1, loadApprovedV1, loadDraftV1 } from 'client/actions/DocumentsV1/draftV1/draftV1Actions'
import { loadNewReceiptDraftThunk } from 'client/actions/DocumentsV1/receiptActions'
import { IThunkAction } from 'client/actions/index'
import { setNavigationPath } from 'client/actions/navigation'
import { getDocumentV1 } from 'client/api/document'
import * as api from 'client/api/draft'
import { DeliverynoteDraftInterface } from 'client/components/DocumentsV1/Deliverynote/DeliverynoteInterface'
import { ReceiptDraftInterface } from 'client/components/DocumentsV1/Receipt/ReceiptInterface'
import { IGraphQl } from 'client/graphQueries/IGraphQl'
import { DocumentType, DocumentTypes } from 'client/Interfaces/Draft/DraftInterface'
import { ConfigInterface } from 'client/Interfaces/Draft/v1/DraftInterface'
import { EditedDraftV1Interface } from 'client/Interfaces/Draft/v1/EditedDraftV1Interface'

type DraftInterface = ReceiptDraftInterface | DeliverynoteDraftInterface
export const initDraftThunkV1 = (
  type: DocumentType,
  config: IGraphQl<ConfigInterface>,
): IThunkAction<null, EditedDraftV1Interface, Promise<void>> => {
  return async (dispatch) => {
    if (type === DocumentTypes.DELIVERYNOTE) {
      await dispatch(loadNewDeliverynoteDraftThunk(config))
    } else if (type === DocumentTypes.RECEIPT) {
      await dispatch(loadNewReceiptDraftThunk(config))
    }
  }
}

export const loadDraftThunkV1 = (type: DocumentType, id: number): IThunkAction<null, DraftInterface, Promise<void>> => {
  return async (dispatch) => {
    const draft = await api.getDraftV1(type, id)
    dispatch(loadDraftV1(draft))
  }
}

export const loadApprovedThunkV1 = (
  type: DocumentType,
  id: number,
): IThunkAction<null, DraftInterface, Promise<void>> => {
  return async (dispatch) => {
    const approvedDocument = await getDocumentV1<DraftInterface>(type, id)
    dispatch(loadApprovedV1(approvedDocument))
  }
}

export const copyDraftThunkV1 = (
  documentType: DocumentTypes,
  id: number,
): IThunkAction<null, DraftInterface | string> => {
  return async (dispatch) => {
    const copiedDraft = await api.getDraftV1(documentType, id)
    dispatch(copyDraftV1(copiedDraft))
    if (documentType === DocumentTypes.DELIVERYNOTE) {
      dispatch(setNavigationPath('/editor/deliverynotes/drafts/new'))
    } else if (documentType === DocumentTypes.RECEIPT) {
      dispatch(setNavigationPath('/editor/receipts/drafts/new'))
    }
  }
}
